import { Component, Renderer2 } from '@angular/core';
import { ViewController } from 'ionic-angular';
@Component({
  selector: 'eta-warning-modal',
  templateUrl: 'eta-warning-modal.html',
})
export class EtaWarningModalComponent {
  warningDescription: string;
  shouldProceed: boolean = false;

  constructor(private renderer: Renderer2, private viewCtrl: ViewController) {
    console.log('Hello EtaWarningModalComponent Component');
    this.warningDescription =
      "You are sending an ETA well before the customer's expected target time window. Are you sure you want proceed? The customer's vehicle may not be there when you arrive.";
    this.renderer.addClass(
      this.viewCtrl.pageRef().nativeElement,
      'ops-eta-warning-modal'
    );
    this.renderer.addClass(
      this.viewCtrl.pageRef().nativeElement,
      'app-yoshi-modal'
    );
  }

  didTapNevermind() {
    this.dismiss();
  }

  didTapSend() {
    this.shouldProceed = true;
    this.dismiss();
  }

  dismiss() {
    this.viewCtrl.dismiss(this.shouldProceed);
  }
}



// WEBPACK FOOTER //
// ./src/components/eta-warning-modal/eta-warning-modal.ts